import type { TimeReport } from "../api";
import { TimeEntryType } from "../time-entries/time-entry-type";

export type TimeReportAggregate = {
    work: { days: number; hours: number };
    vacation: { days: number; hours: number };
    sick: { days: number; hours: number };
    adjustments: { days: number; hours: number };
    comp: { days: number; hours: number };
};

export function aggregateTimeReportItems(items: TimeReport["items"]): TimeReportAggregate {
    return items.reduce(
        (acc, { type, days, hours }) => {
            switch (type) {
                case TimeEntryType.Work:
                    acc.work.days += days;
                    acc.work.hours += hours;
                    break;
                case TimeEntryType.Vacation:
                    acc.vacation.days += days;
                    acc.vacation.hours += hours;
                    break;
                case TimeEntryType.Sick:
                case TimeEntryType.ChildSick:
                case TimeEntryType.SickInKUG:
                    acc.sick.days += days;
                    acc.sick.hours += hours;
                    break;
                case TimeEntryType.HourAdjustment:
                    acc.adjustments.days += days;
                    acc.adjustments.hours += hours;
                    break;
                case TimeEntryType.CompDay:
                    acc.comp.days += days;
                    acc.comp.hours += hours;
                    break;
            }
            return acc;
        },
        {
            work: { days: 0, hours: 0 },
            vacation: { days: 0, hours: 0 },
            sick: { days: 0, hours: 0 },
            adjustments: { days: 0, hours: 0 },
            comp: { days: 0, hours: 0 },
        }
    );
}